import { environment } from "src/environments/environment"

export const assets_version = environment.ASSETS_VERSION
export const base_markers = environment.path_imgs_markers + "/"

export const ITALY_BOUNDS = {
	north: 47.1153931748,
	south: 36.619987291,
	east: 18.4802470232,
	west: 6.7499552751
}

export const ITALY_CENTER = {
	lat: (ITALY_BOUNDS.north + ITALY_BOUNDS.south) / 2,
	lng: (ITALY_BOUNDS.east + ITALY_BOUNDS.west) / 2
}

export const CONFIG_LINE = {
	strokeWeight: 4,
	strokeOpacity: 1,
	strokeColor: "#F33279"
}

export const CONFIG_LINE_INNER = {
	strokeWeight: 2,
	strokeOpacity: 0.8,
	strokeColor: "#FFF"
}

export const ico_civic_picked = {
	url: base_markers + "civic_marker_dark_blue.png",
	size: new google.maps.Size(30, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 15),
	zIndex: 100
}

export const ico_picked = {
	url: base_markers + "picked_marker.png",
	size: new google.maps.Size(30, 40),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 30)
}

export const ico_preview = {
	url: base_markers + "gmarker.png",
	size: new google.maps.Size(20, 20),
	scaledSize: new google.maps.Size(20, 20),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(20, 20)
}

export const ico_picked_p2p = {
	url: base_markers + "picked_marker_p2p.png",
	size: new google.maps.Size(30, 40),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 30)
}

export const ico_interest_point = {
	url: base_markers + "poi.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(30, 40),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 30)
}

export const ico_interest_point_smaller = {
	url: base_markers + "poi_map_smaller.png",
	size: new google.maps.Size(13, 20),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(10, 20)
}

export const ico_interest_point_grey = {
	url: base_markers + "poi_grey.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(30, 40),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 30)
}

export const ico_interest_point_grey_smaller = {
	url: base_markers + "poi_grey_smaller.png",
	size: new google.maps.Size(13, 20),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(10, 20)
}

export const ico_interest_point_pink = {
	url: base_markers + "poi_pink.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(30, 40),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 30)
}

export const ico_interest_point_pink_smaller = {
	url: base_markers + "poi_pink_smaller.png",
	size: new google.maps.Size(13, 20),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(10, 20)
}

export const ico_active_p2p = {
	url: base_markers + "actived_marker_p2p.svg",
	size: new google.maps.Size(48, 48),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(24, 48)
}

export const ico_active = {
	url: base_markers + "actived_marker.svg",
	size: new google.maps.Size(48, 48),
	// scaledSize: new google.maps.Size(25, 25),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(24, 48)
}

export const ico_civic = {
	url: base_markers + "civic_marker.png",
	size: new google.maps.Size(30, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 15),
	zIndex: 90
}

export const ico_civic_man = {
	url: base_markers + "marker_man.png",
	size: new google.maps.Size(30, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 15),
	zIndex: 90
}

export const ico_civic_cd = {
	url: base_markers + "civic_marker.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(30, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 15)
}

export const ico_pop_naz = {
	url: base_markers + "pop_marker_edge.png",
	size: new google.maps.Size(30, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 30)
}
export const ico_pop_naz_smaller = {
	url: base_markers + "pop_marker_edge_smaller.png",
	size: new google.maps.Size(13, 20),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(10, 20)
}

export const ico_pcn = {
	url: base_markers + "ico_pcn.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(30, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 30)
}
export const ico_pcn_smaller = {
	url: base_markers + "ico_pcn_smaller.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(13, 20),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(10, 20)
}

export const ico_pop_grey = {
	url: base_markers + "pop_grey.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(20, 30),
	scaledSize: new google.maps.Size(20, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 30)
}
export const ico_pop_grey_smaller = {
	url: base_markers + "pop_grey_smaller.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(13, 20),
	scaledSize: new google.maps.Size(13, 20),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(10, 20)
}

export const ico_pop_green = {
	url: base_markers + "ico_pcn_green.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(20, 30),
	scaledSize: new google.maps.Size(20, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 30)
}
export const ico_pop_green_smaller = {
	url: base_markers + "ico_pcn_green_smaller.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(13, 20),
	scaledSize: new google.maps.Size(13, 20),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(10, 20)
}

export const ico_pop_green_light = {
	url: base_markers + "ico_pcn_green_light.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(20, 30),
	scaledSize: new google.maps.Size(20, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 30)
}
export const ico_pop_green_light_smaller = {
	url: base_markers + "ico_pcn_green_light_smaller.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(13, 20),
	scaledSize: new google.maps.Size(13, 20),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(10, 20)
}

export const ico_pop_orange = {
	url: base_markers + "ico_pcn_orange.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(20, 30),
	scaledSize: new google.maps.Size(20, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 30)
}
export const ico_pop_orange_smaller = {
	url: base_markers + "ico_pcn_orange_smaller.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(13, 20),
	scaledSize: new google.maps.Size(13, 20),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(10, 20)
}

export const ico_pop_yellow = {
	url: base_markers + "pop_marker_yellow.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(20, 30),
	scaledSize: new google.maps.Size(20, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 30)
}
export const ico_pop_yellow_smaller = {
	url: base_markers + "pop_marker_yellow_smaller.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(13, 20),
	scaledSize: new google.maps.Size(13, 20),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(10, 20)
}

export const ico_pop_blue = {
	url: base_markers + "pop_marker_blue.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(30, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 30)
}
export const ico_pop_blue_smaller = {
	url: base_markers + "pop_marker_blue_smaller.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(13, 20),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(10, 20)
}

// NEW

export const icon_building_ftth_pink = {
	url: base_markers + "civic_marker.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(30, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 15),
	zIndex: 90
}

export const icon_building_man_pink = {
	url: base_markers + "marker_man.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(30, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 15),
	zIndex: 90
}

export const icon_building_ftth_green = {
	url: base_markers + "civic_marker.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(30, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 15),
	zIndex: 90
}

export const icon_building_ftth_blue = {
	url: base_markers + "civic_marker_blue.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(30, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 15),
	zIndex: 90
}

export const icon_building_ftth_blue_dark = {
	url: base_markers + "civic_marker_blue_dark.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(30, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 15),
	zIndex: 90
}

export const icon_building_man_blue = {
	url: base_markers + "marker_man_blue.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(50, 50),
	scaledSize: new google.maps.Size(50, 50),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(30, 30),
	zIndex: 90
}

export const icon_cluster_pink = {
	url: base_markers + "cluster.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(60, 60),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(30, 30),
	zIndex: 90
}

export const icon_cluster_green = {
	url: base_markers + "cluster.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(60, 60),
	scaledSize: new google.maps.Size(60, 60),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(30, 30),
	zIndex: 90
}

export const icon_cluster_blue = {
	url: base_markers + "civic_marker_blue.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(60, 60),
	scaledSize: new google.maps.Size(60, 60),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(30, 30),
	zIndex: 90
}

export const icon_cluster_blue_dark = {
	url: base_markers + "civic_marker_blue_dark.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(60, 60),
	scaledSize: new google.maps.Size(60, 60),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(30, 30),
	zIndex: 90
}

export const icon_POP_pink = {
	url: base_markers + "pop_marker_edge.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(30, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 30)
}

export const icon_POP_green = {
	url: base_markers + "ico-pop-cd.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(30, 30),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 30)
}

export const icon_poi = {
	url: base_markers + "poi_map.png?v={{" + assets_version + "}}",
	size: new google.maps.Size(30, 40),
	origin: new google.maps.Point(0, 0),
	anchor: new google.maps.Point(15, 30)
}

export const icon = {
	FTTH: {
		covered_ab: icon_building_ftth_pink,
		covered_cd: icon_building_ftth_green,
		covered_agf: icon_building_ftth_blue_dark, // TODO icona
		prospect: icon_building_ftth_blue
	},
	MAN: {
		covered_ab: icon_building_ftth_pink,
		covered_agf: icon_building_ftth_blue_dark, // TODO icona
		prospect: icon_building_ftth_blue
	},
	cluster: {
		covered_ab: icon_cluster_pink,
		covered_cd: icon_cluster_green,
		covered_agf: icon_cluster_blue_dark, // TODO icona
		prospect: icon_cluster_blue
	},
	POP: {
		covered_ab: icon_POP_pink,
		covered_cd: icon_POP_green,
		covered_agf: ico_pop_blue
	},
	POI: {
		null: icon_poi
	},
	PICKED: {
		null: ico_preview
	},
	POINT_B_END: {
		null: ico_picked
	},
	POINT_A_END: {
		null: ico_picked_p2p
	},
	POINT_B_END_BUILDING: {
		null: ico_active
	},
	POINT_A_END_BUILDING: {
		null: ico_active_p2p
	}
}

// To be used as marker when place is selected
export const iconMarker = {
	// area type -> type -> end
	null: {
		POINT_PLACE: {
			B: ico_picked,
			A: ico_picked_p2p
		},
		POINT_CIVIC: {
			B: ico_active,
			A: ico_active_p2p
		},
		POINT_PICKED: {
			B: ico_picked,
			A: ico_picked_p2p
		},
		PICKED: {
			B: ico_picked,
			A: ico_picked_p2p
		},
		FTTH: {
			B: ico_active,
			A: ico_active_p2p
		},
		MAN: {
			B: ico_active,
			A: ico_active_p2p
		},
		POI: {
			B: icon_poi,
			A: icon_poi
		}
	},
	covered_ab: {
		POP: {
			B: icon_POP_pink,
			A: icon_POP_pink
		}
	},
	covered_cd: {
		POP: {
			B: icon_POP_green,
			A: icon_POP_green
		}
	},
	covered_agf: {
		POP: {
			B: ico_pop_blue,
			A: ico_pop_blue
		}
	}
}
